import { render, staticRenderFns } from "./Farmacia.vue?vue&type=template&id=6069937b&scoped=true&"
import script from "./Farmacia.vue?vue&type=script&lang=js&"
export * from "./Farmacia.vue?vue&type=script&lang=js&"
import style0 from "./Farmacia.vue?vue&type=style&index=0&id=6069937b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6069937b",
  null
  
)

export default component.exports